import { CircularProgress } from "@mui/material";

export function ButtonSpinnerWhite(props) {
    return (
        <CircularProgress size={24} sx={{ color: 'white' }} {...props} />
    )
}

export function ButtonSpinnerBlue(props) {
    return (
        <CircularProgress size={24} sx={{ color: 'blue', alignContent: 'center' }} {...props} />
    )
}

export function ButtonSpinnerGreen(props) {
    return (
        <CircularProgress size={20} color="success" {...props} />
    )
}